export const filter = {
    id: "",
    comment: "",
    search: "",
    created_at: "",
    updated_at: "",
};
